import { HeroUIProvider } from '@heroui/react';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { router } from './routes';

function App() {
  return (
    <HeroUIProvider>
      <RouterProvider router={router} />
      <Toaster />
    </HeroUIProvider>
  );
}

export default App;
